import { render, staticRenderFns } from "./provider-paymentconfirmation.vue?vue&type=template&id=6dfcbff7&scoped=true"
import script from "./provider-paymentconfirmation.vue?vue&type=script&lang=js"
export * from "./provider-paymentconfirmation.vue?vue&type=script&lang=js"
import style0 from "./provider-paymentconfirmation.vue?vue&type=style&index=0&id=6dfcbff7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfcbff7",
  null
  
)

export default component.exports